import { WebsiteRouteConfig } from '@/modules/seo/website/WebsiteRouteConfig';
import { WebsiteRouteNames } from '@/modules/seo/website/website.constants';
import { KeywordTrackingRouteConfig } from '@/modules/seo/keywordtracking/KeywordTrackingRouteConfig';
import { SiteAuditorRouteConfig } from '@/modules/seo/siteauditor/SiteAuditorRouteConfig';

export const router = [
  WebsiteRouteConfig.factory({
    path: '/raven',
    redirect: '/raven/websites',
  }),
  WebsiteRouteConfig.factory({
    path: '/raven/gettingstarted',
    name: WebsiteRouteNames.GETTING_STARTED,
    component: () =>
      import(/* webpackChunkName: "raven-getting-started-page" */ './pages/GettingStartedPage.vue'),
    props: true,
  }),
  WebsiteRouteConfig.factory({
    path: '/raven/websites',
    name: WebsiteRouteNames.WEBSITES,
    component: () => import(/* webpackChunkName: "websites-page" */ './pages/WebsitesPage.vue'),
  }),
  KeywordTrackingRouteConfig.factory({
    path: '/raven/websites/new/keywordtracking',
    name: WebsiteRouteNames.KEYWORD_TRACKING_NEW,
    component: () =>
      import(
        /* webpackChunkName: "keyword-tracking-form-page" */ './pages/KeywordTrackingFormPage.vue'
      ),
    props: true,
  }),
  KeywordTrackingRouteConfig.factory({
    path: '/raven/websites/:id(\\d+)/edit/keywordtracking/:activeStep?',
    name: WebsiteRouteNames.KEYWORD_TRACKING_EDIT,
    component: () =>
      import(
        /* webpackChunkName: "keyword-tracking-form-page" */ './pages/KeywordTrackingFormPage.vue'
      ),
    props: true,
  }),
  SiteAuditorRouteConfig.factory({
    path: '/raven/websites/new/siteauditor',
    name: WebsiteRouteNames.SITE_AUDITING_NEW,
    component: () =>
      import(/* webpackChunkName: "site-auditing-form-page" */ './pages/SiteAuditingFormPage.vue'),
    props: true,
  }),
  SiteAuditorRouteConfig.factory({
    path: '/raven/websites/:id(\\d+)/edit/siteauditor/:activeStep?',
    name: WebsiteRouteNames.SITE_AUDITING_EDIT,
    component: () =>
      import(/* webpackChunkName: "site-auditing-form-page" */ './pages/SiteAuditingFormPage.vue'),
    props: true,
  }),
];
